exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown[data-v-2d5174ad] {\n  max-width: 300px;\n}\n@media (min-width: 768px) {\n.dropdown[data-v-2d5174ad] {\n    max-width: 200px;\n}\n}", ""]);

// exports
